import api from "../services/api";

interface ISectorProductivityResponse {
    codeResult: string;
    data: any[];
}

export interface ISectorProductivityParams {
    dataInicial: string;
    dataFinal: string;

}
export interface ISectorProductivityMonth {
    gerente: string;
    quantidade: number;
}


class SectorProductivityRepository {
    public async PartialMonth({ dataInicial, dataFinal }: ISectorProductivityParams): Promise<ISectorProductivityMonth[]> {   
        
        const body = {
            "tables": ["Kit", "Pedido", "GerenteSetor"],
            "sql": [
                {
                    "coderesult": "SetorProdutividade",
                    "query": `SELECT GerenteSetor.nome as Gerente, COUNT(Kit.id) as Qtd 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Pedido.gerenteSetorId 
                    WHERE Kit.tipo = 0 
                    AND Kit.dataEntrega >= '${dataInicial}' 
                    AND Kit.dataEntrega < '${dataFinal}T23:59:59Z'
                    AND Kit.estado = 0 
                    AND Kit.statusKit = 3
                    GROUP BY GerenteSetor.nome 
                    ORDER BY Qtd DESC`
                }
            ]
        };

        const response = await api.post<ISectorProductivityResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "SetorProdutividade").map(result => {
            return {
                gerente: result.Gerente,
                quantidade: result.Qtd
            }
        });
    }

    GetFromCodeResult(data: ISectorProductivityResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const sectorProductivityRepository = new SectorProductivityRepository();
export default sectorProductivityRepository;